import TvIcon from '../../icons/activities/computer.svg'
import BuildingIcon from '../../icons/building.svg'
import BuildingGroupsIcon from '../../icons/buildings-group.svg'
import UsersIcon from '../../icons/users-1.svg'

export const NEWSBOARD_POST_TYPE = 'post'

export const NEWSBOARD_TICKER_TYPE = 'ticker'

export const NEWSBOARD_POST_MESSAGE_FIELD_NAME = 'text'

export const NEWSBOARD_POST_TICKER_MESSAGE_MAX_LENGTH = 120

export const NEWSBOARD_FEEDBACK_TYPE = 'feedback'

export const NEWSBOARD_SYSTEM_TYPE = 'system_post'

export const NEWSBOARD_TYPES_KEYS = {
  [NEWSBOARD_FEEDBACK_TYPE]: 'Newsboard.FeedTypeKey',
  [NEWSBOARD_POST_TYPE]: 'Newsboard.PostTypeKey',
  [NEWSBOARD_SYSTEM_TYPE]: 'Newsboard.SystemTypeKey',
  [NEWSBOARD_TICKER_TYPE]: 'Newsboard.TickerTypeKey',
}

export const NEWSBOARD_WELCOME_CUSTOM_POST_TYPE = 'welcome'

export const NEWSBOARD_REQUEST_STATUS_CHANGED_TYPE = 'request_status_changed'

export const NEWSBOARD_REQUEST_FEEDBACK_TYPE = 'feedback_post'

export const NEWSBOARD_POST_AUDIENCE_PERSONAL_STATUS = 'personal_status'

export const NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS =
  'ToSignedUpDwellers'

export const NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS =
  'ToNotSignedUpDwellers'

export const NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD = 'ToDigitalBoard'

export const NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS =
  'ToSignedUpLandlords'

export const NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS =
  'ToNotSignedUpLandlords'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_FRIENDS = 'ToAllFriends'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_COLLEAGUES = 'ToAllColleagues'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_SIGNED_UP = 'ToAllSignedUp'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_NOT_SIGNED_UP = 'ToAllNotSignedUp'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS = 'ToAllBuildings'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDING_GROUPS =
  'ToAllBuildingGroups'

export const NEWSBOARD_POST_AUDIENCE_TO_BUILDING = 'ToBuilding'

export const NEWSBOARD_POST_AUDIENCE_TO_ALL_DWELLERS = 'ToAllDwellers'

export const NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING = 'RequestBuilding'

export const NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING_GROUP =
  'RequestBuildingGroup'

export const NEWSBOARD_POST_HIDE_WELCOME_POST_STORAGE_NAME =
  'bs_hide_welcome_post'

export const NEWSBOARD_POST_TAG_LINK_BUILDING = 'building'

export const NEWSBOARD_POST_TAG_LINK_BUILDING_GROUP = 'building-group'

export const BUILDING_REQUIRED_AUDIENCE = [
  NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
]

export const NEWSBOARD_POST_AUDIENCE = {
  [NEWSBOARD_POST_AUDIENCE_PERSONAL_STATUS]: {
    Icon: UsersIcon,
  },
  [NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING]: {
    Icon: BuildingIcon,
    hoverable: true,
    to: NEWSBOARD_POST_TAG_LINK_BUILDING,
  },
  [NEWSBOARD_POST_AUDIENCE_REQUEST_BUILDING_GROUP]: {
    Icon: BuildingGroupsIcon,
    hoverable: true,
    to: NEWSBOARD_POST_TAG_LINK_BUILDING_GROUP,
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDING_GROUPS]: {
    Icon: BuildingGroupsIcon,
    titleKey: 'Newsboard.ToAllBuildingGroupsKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS]: {
    Icon: BuildingIcon,
    titleKey: 'Newsboard.ToAllBuildingsKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_COLLEAGUES]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToAllColleaguesKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_DWELLERS]: {
    Icon: BuildingIcon,
    titleKey: 'Newsboard.AudienceToAllDwellersKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_FRIENDS]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToAllFriendsKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_NOT_SIGNED_UP]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToAllNotSignedUpKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_ALL_SIGNED_UP]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToAllSignedUpKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_BUILDING]: {
    Icon: BuildingIcon,
    hoverable: true,
    to: NEWSBOARD_POST_TAG_LINK_BUILDING,
  },
  [NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD]: {
    Icon: TvIcon,
    titleKey: 'Newsboard.AudienceToDigitalBoardKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToNotSignedUpDwellersKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToNotSignedUpLandlordsKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToSignedUpDwellersKey',
  },
  [NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS]: {
    Icon: UsersIcon,
    titleKey: 'Newsboard.AudienceToSignedUpLandlordsKey',
  },
}
